import { ApiReductionGoalResponse } from '../../../api/core/models';
import { BoardReductionGoal } from '../../../model/board-reduction-goal';

export function apiBoardReductionGoalsToBoardReductionGoals(
  apiBoardReductionGoals?: Omit<ApiReductionGoalResponse, 'createdAt' | 'updatedAt'>[]
): BoardReductionGoal[] {
  if (!apiBoardReductionGoals) {
    return [];
  }
  return apiBoardReductionGoals.map((reductionGoal) => ({
    id: reductionGoal.id,
    goal: reductionGoal.goal,
    referenceYear: reductionGoal.referenceYear,
    referenceYearEmissions: reductionGoal.referenceYearEmissions,
    ratified: reductionGoal.ratified,
    ...(reductionGoal?.ratifiedDate ? { ratifiedDate: new Date(reductionGoal.ratifiedDate) } : {}),
    additionalGoalsByYear: reductionGoal.additionalGoalsByYear,
  }));
}
